import { AccordionCaretDownIcon as e } from "./AccordionCaretDownIcon/index.js";
import { AccordionCaretUpIcon as o } from "./AccordionCaretUpIcon/index.js";
import { AcneIcon as n } from "./AcneIcon/index.js";
import { Acne1Icon as c } from "./Acne1Icon/index.js";
import { Acne3Icon as a } from "./Acne3Icon/index.js";
import { Acne5Icon as r } from "./Acne5Icon/index.js";
import { Acne7Icon as t } from "./Acne7Icon/index.js";
import { AgencyAcneIcon as i } from "./AgencyAcneIcon/index.js";
import { AgencyAcne1Icon as g } from "./AgencyAcne1Icon/index.js";
import { AgencyAcne3Icon as m } from "./AgencyAcne3Icon/index.js";
import { AgencyAcne5Icon as y } from "./AgencyAcne5Icon/index.js";
import { AgencyAcne7Icon as p } from "./AgencyAcne7Icon/index.js";
import { AgencyAlwaysIcon as l } from "./AgencyAlwaysIcon/index.js";
import { AgencyAlwaysClockIcon as s } from "./AgencyAlwaysClockIcon/index.js";
import { AgencyAnxiousIcon as h } from "./AgencyAnxiousIcon/index.js";
import { AgencyArrowLeftIcon as f } from "./AgencyArrowLeftIcon/index.js";
import { AgencyArrowRightIcon as d } from "./AgencyArrowRightIcon/index.js";
import { AgencyAzelaicAcidIcon as A } from "./AgencyAzelaicAcidIcon/index.js";
import { AgencyBagIcon as u } from "./AgencyBagIcon/index.js";
import { AgencyBellIcon as I } from "./AgencyBellIcon/index.js";
import { AgencyCalendarIcon as k } from "./AgencyCalendarIcon/index.js";
import { AgencyCameraIcon as b } from "./AgencyCameraIcon/index.js";
import { AgencyChatBubbleIcon as C } from "./AgencyChatBubbleIcon/index.js";
import { AgencyCheckBadgeIcon as v } from "./AgencyCheckBadgeIcon/index.js";
import { AgencyCheckmarkIcon as w } from "./AgencyCheckmarkIcon/index.js";
import { AgencyChestIcon as S } from "./AgencyChestIcon/index.js";
import { AgencyChevronIcon as L } from "./AgencyChevronIcon/index.js";
import { AgencyCircleIcon as P } from "./AgencyCircleIcon/index.js";
import { AgencyCircleAddIcon as T } from "./AgencyCircleAddIcon/index.js";
import { AgencyCircleCheckmarkIcon as F } from "./AgencyCircleCheckmarkIcon/index.js";
import { AgencyCircleRemoveIcon as M } from "./AgencyCircleRemoveIcon/index.js";
import { AgencyCleanserIcon as H } from "./AgencyCleanserIcon/index.js";
import { AgencyClipboardIcon as D } from "./AgencyClipboardIcon/index.js";
import { AgencyClockIcon as x } from "./AgencyClockIcon/index.js";
import { AgencyCloggedPoresIcon as z } from "./AgencyCloggedPoresIcon/index.js";
import { AgencyCloudIcon as O } from "./AgencyCloudIcon/index.js";
import { AgencyCombinationIcon as B } from "./AgencyCombinationIcon/index.js";
import { AgencyConfusedIcon as V } from "./AgencyConfusedIcon/index.js";
import { AgencyConsultHistoryIcon as N } from "./AgencyConsultHistoryIcon/index.js";
import { AgencyCrossIcon as R } from "./AgencyCrossIcon/index.js";
import { AgencyDarkSpotsIcon as U } from "./AgencyDarkSpotsIcon/index.js";
import { AgencyDownloadIcon as E } from "./AgencyDownloadIcon/index.js";
import { AgencyDropIcon as q } from "./AgencyDropIcon/index.js";
import { AgencyDropperIcon as G } from "./AgencyDropperIcon/index.js";
import { AgencyEditIcon as j } from "./AgencyEditIcon/index.js";
import { AgencyElatedIcon as W } from "./AgencyElatedIcon/index.js";
import { AgencyEqualsIcon as K } from "./AgencyEqualsIcon/index.js";
import { AgencyErrorIcon as Y } from "./AgencyErrorIcon/index.js";
import { AgencyEyeClosedIcon as J } from "./AgencyEyeClosedIcon/index.js";
import { AgencyFaceIcon as Z } from "./AgencyFaceIcon/index.js";
import { AgencyFemaleIcon as Q } from "./AgencyFemaleIcon/index.js";
import { AgencyFinelinesIcon as X } from "./AgencyFinelinesIcon/index.js";
import { AgencyFirmnessIcon as _ } from "./AgencyFirmnessIcon/index.js";
import { AgencyFirmnessFlagIcon as $ } from "./AgencyFirmnessFlagIcon/index.js";
import { AgencyFlagIcon as ee } from "./AgencyFlagIcon/index.js";
import { AgencyFlagCanadaIcon as oe } from "./AgencyFlagCanadaIcon/index.js";
import { AgencyFlagUkIcon as ne } from "./AgencyFlagUkIcon/index.js";
import { AgencyFlagUsaIcon as ce } from "./AgencyFlagUsaIcon/index.js";
import { AgencyFuriousIcon as ae } from "./AgencyFuriousIcon/index.js";
import { AgencyGiftIcon as re } from "./AgencyGiftIcon/index.js";
import { AgencyGlobeIcon as te } from "./AgencyGlobeIcon/index.js";
import { AgencyGridIcon as ie } from "./AgencyGridIcon/index.js";
import { AgencyHeartIcon as ge } from "./AgencyHeartIcon/index.js";
import { AgencyHeartCompleteIcon as me } from "./AgencyHeartCompleteIcon/index.js";
import { AgencyHelpIcon as ye } from "./AgencyHelpIcon/index.js";
import { AgencyHomeIcon as pe } from "./AgencyHomeIcon/index.js";
import { AgencyHugIcon as le } from "./AgencyHugIcon/index.js";
import { AgencyImageIcon as se } from "./AgencyImageIcon/index.js";
import { AgencyInfoIcon as he } from "./AgencyInfoIcon/index.js";
import { AgencyLightningIcon as fe } from "./AgencyLightningIcon/index.js";
import { AgencyLocationIcon as de } from "./AgencyLocationIcon/index.js";
import { AgencyLockIcon as Ae } from "./AgencyLockIcon/index.js";
import { AgencyLogoIcon as ue } from "./AgencyLogoIcon/index.js";
import { AgencyLogoLockupIcon as Ie } from "./AgencyLogoLockupIcon/index.js";
import { AgencyLogoLockupInverseIcon as ke } from "./AgencyLogoLockupInverseIcon/index.js";
import { AgencyLogoStickerIcon as be } from "./AgencyLogoStickerIcon/index.js";
import { AgencyLogoStickerInverseIcon as Ce } from "./AgencyLogoStickerInverseIcon/index.js";
import { AgencyLogoWordmarkIcon as ve } from "./AgencyLogoWordmarkIcon/index.js";
import { AgencyLogoutIcon as we } from "./AgencyLogoutIcon/index.js";
import { AgencyLunchIcon as Se } from "./AgencyLunchIcon/index.js";
import { AgencyMailIcon as Le } from "./AgencyMailIcon/index.js";
import { AgencyMaleIcon as Pe } from "./AgencyMaleIcon/index.js";
import { AgencyMelasmaIcon as Te } from "./AgencyMelasmaIcon/index.js";
import { AgencyMenuIcon as Fe } from "./AgencyMenuIcon/index.js";
import { AgencyMessageIcon as Me } from "./AgencyMessageIcon/index.js";
import { AgencyMicIcon as He } from "./AgencyMicIcon/index.js";
import { AgencyMildIrritationIcon as De } from "./AgencyMildIrritationIcon/index.js";
import { AgencyMinusIcon as xe } from "./AgencyMinusIcon/index.js";
import { AgencyMixIngredientsIcon as ze } from "./AgencyMixIngredientsIcon/index.js";
import { AgencyMoisturizerIcon as Oe } from "./AgencyMoisturizerIcon/index.js";
import { AgencyMoreIcon as Be } from "./AgencyMoreIcon/index.js";
import { AgencyMortorIcon as Ve } from "./AgencyMortorIcon/index.js";
import { AgencyMostOfTimeIcon as Ne } from "./AgencyMostOfTimeIcon/index.js";
import { AgencyMostOfTimeClockIcon as Re } from "./AgencyMostOfTimeClockIcon/index.js";
import { AgencyNeckIcon as Ue } from "./AgencyNeckIcon/index.js";
import { AgencyNeverIcon as Ee } from "./AgencyNeverIcon/index.js";
import { AgencyNeverClockIcon as qe } from "./AgencyNeverClockIcon/index.js";
import { AgencyNiacinamideIcon as Ge } from "./AgencyNiacinamideIcon/index.js";
import { AgencyNoMakeupIcon as je } from "./AgencyNoMakeupIcon/index.js";
import { AgencyNoneIcon as We } from "./AgencyNoneIcon/index.js";
import { AgencyNoticeableIrritationIcon as Ke } from "./AgencyNoticeableIrritationIcon/index.js";
import { AgencyOftenDryIcon as Ye } from "./AgencyOftenDryIcon/index.js";
import { AgencyOftenOilyIcon as Je } from "./AgencyOftenOilyIcon/index.js";
import { AgencyOtherIcon as Ze } from "./AgencyOtherIcon/index.js";
import { AgencyOverwhelmedIcon as Qe } from "./AgencyOverwhelmedIcon/index.js";
import { AgencyPackagingIcon as Xe } from "./AgencyPackagingIcon/index.js";
import { AgencyPalmTreeIcon as _e } from "./AgencyPalmTreeIcon/index.js";
import { AgencyPaperclipIcon as $e } from "./AgencyPaperclipIcon/index.js";
import { AgencyPauseIcon as eo } from "./AgencyPauseIcon/index.js";
import { AgencyPaymentIcon as oo } from "./AgencyPaymentIcon/index.js";
import { AgencyPhoneIcon as no } from "./AgencyPhoneIcon/index.js";
import { AgencyPlanIcon as co } from "./AgencyPlanIcon/index.js";
import { AgencyPlayIcon as ao } from "./AgencyPlayIcon/index.js";
import { AgencyPlusIcon as ro } from "./AgencyPlusIcon/index.js";
import { AgencyPreparedIcon as to } from "./AgencyPreparedIcon/index.js";
import { AgencyProviderIcon as io } from "./AgencyProviderIcon/index.js";
import { AgencyRocketshipIcon as go } from "./AgencyRocketshipIcon/index.js";
import { AgencySatisfiedIcon as mo } from "./AgencySatisfiedIcon/index.js";
import { AgencySearchIcon as yo } from "./AgencySearchIcon/index.js";
import { AgencySelfiesIcon as po } from "./AgencySelfiesIcon/index.js";
import { AgencySettingsIcon as lo } from "./AgencySettingsIcon/index.js";
import { AgencySevereIrritationIcon as so } from "./AgencySevereIrritationIcon/index.js";
import { AgencySmileIcon as ho } from "./AgencySmileIcon/index.js";
import { AgencySmileyIcon as fo } from "./AgencySmileyIcon/index.js";
import { AgencySometimesIcon as Ao } from "./AgencySometimesIcon/index.js";
import { AgencySometimesClockIcon as uo } from "./AgencySometimesClockIcon/index.js";
import { AgencySparkleIcon as Io } from "./AgencySparkleIcon/index.js";
import { AgencyStarIcon as ko } from "./AgencyStarIcon/index.js";
import { AgencySunIcon as bo } from "./AgencySunIcon/index.js";
import { AgencySunblockIcon as Co } from "./AgencySunblockIcon/index.js";
import { AgencySunscreenIcon as vo } from "./AgencySunscreenIcon/index.js";
import { AgencySuperbottleIcon as wo } from "./AgencySuperbottleIcon/index.js";
import { AgencySupportCenterIcon as So } from "./AgencySupportCenterIcon/index.js";
import { AgencyTemperatureIcon as Lo } from "./AgencyTemperatureIcon/index.js";
import { AgencyTextureIcon as Po } from "./AgencyTextureIcon/index.js";
import { AgencyThumbsDownIcon as To } from "./AgencyThumbsDownIcon/index.js";
import { AgencyThumbsUpIcon as Fo } from "./AgencyThumbsUpIcon/index.js";
import { AgencyTimerIcon as Mo } from "./AgencyTimerIcon/index.js";
import { AgencyTransferIcon as Ho } from "./AgencyTransferIcon/index.js";
import { AgencyTrashIcon as Do } from "./AgencyTrashIcon/index.js";
import { AgencyTreatmentIcon as xo } from "./AgencyTreatmentIcon/index.js";
import { AgencyTreatmentPlanIcon as zo } from "./AgencyTreatmentPlanIcon/index.js";
import { AgencyTretinoinIcon as Oo } from "./AgencyTretinoinIcon/index.js";
import { AgencyTruckIcon as Bo } from "./AgencyTruckIcon/index.js";
import { AgencyUnsatisfiedIcon as Vo } from "./AgencyUnsatisfiedIcon/index.js";
import { AgencyUploadIcon as No } from "./AgencyUploadIcon/index.js";
import { AgencyUserIcon as Ro } from "./AgencyUserIcon/index.js";
import { AgencyVeryDryIcon as Uo } from "./AgencyVeryDryIcon/index.js";
import { AgencyVeryOilyIcon as Eo } from "./AgencyVeryOilyIcon/index.js";
import { AgencyVideoIcon as qo } from "./AgencyVideoIcon/index.js";
import { AgencyVitaminCIcon as Go } from "./AgencyVitaminCIcon/index.js";
import { AgencyVitaminCSerumIcon as jo } from "./AgencyVitaminCSerumIcon/index.js";
import { AgencyWrinklesIcon as Wo } from "./AgencyWrinklesIcon/index.js";
import { AgencyYesIcon as Ko } from "./AgencyYesIcon/index.js";
import { AmexIcon as Yo } from "./AmexIcon/index.js";
import { AppleIcon as Jo } from "./AppleIcon/index.js";
import { ArrowLeftIcon as Zo } from "./ArrowLeftIcon/index.js";
import { ArrowRightIcon as Qo } from "./ArrowRightIcon/index.js";
import { AzelaicAcidIcon as Xo } from "./AzelaicAcidIcon/index.js";
import { BagIcon as _o } from "./BagIcon/index.js";
import { BellIcon as $o } from "./BellIcon/index.js";
import { CalendarIcon as en } from "./CalendarIcon/index.js";
import { CameraIcon as on } from "./CameraIcon/index.js";
import { ChatBubbleIcon as nn } from "./ChatBubbleIcon/index.js";
import { CheckmarkIcon as cn } from "./CheckmarkIcon/index.js";
import { ChestIcon as an } from "./ChestIcon/index.js";
import { ChevronIcon as rn } from "./ChevronIcon/index.js";
import { CircleIcon as tn } from "./CircleIcon/index.js";
import { CircleAddIcon as gn } from "./CircleAddIcon/index.js";
import { CircleCheckIcon as mn } from "./CircleCheckIcon/index.js";
import { CircleRemoveIcon as yn } from "./CircleRemoveIcon/index.js";
import { ClindamycinIcon as pn } from "./ClindamycinIcon/index.js";
import { ClipboardIcon as ln } from "./ClipboardIcon/index.js";
import { ClockIcon as sn } from "./ClockIcon/index.js";
import { CloggedPoresIcon as hn } from "./CloggedPoresIcon/index.js";
import { CloudIcon as fn } from "./CloudIcon/index.js";
import { CombinationIcon as dn } from "./CombinationIcon/index.js";
import { ContrastIcon as An } from "./ContrastIcon/index.js";
import { CrossIcon as un } from "./CrossIcon/index.js";
import { CurologyLogoLockupIcon as In } from "./CurologyLogoLockupIcon/index.js";
import { CurologyLogoLockupInverseIcon as kn } from "./CurologyLogoLockupInverseIcon/index.js";
import { CurologyLogoStickerIcon as bn } from "./CurologyLogoStickerIcon/index.js";
import { CurologyLogoWordmarkIcon as Cn } from "./CurologyLogoWordmarkIcon/index.js";
import { DarkSpotsIcon as vn } from "./DarkSpotsIcon/index.js";
import { DashIcon as wn } from "./DashIcon/index.js";
import { DesonideIcon as Sn } from "./DesonideIcon/index.js";
import { DinersClubIcon as Ln } from "./DinersClubIcon/index.js";
import { DiscoverIcon as Pn } from "./DiscoverIcon/index.js";
import { DotIcon as Tn } from "./DotIcon/index.js";
import { DownloadIcon as Fn } from "./DownloadIcon/index.js";
import { DropIcon as Mn } from "./DropIcon/index.js";
import { EditIcon as Hn } from "./EditIcon/index.js";
import { EqualIcon as Dn } from "./EqualIcon/index.js";
import { ErrorIcon as xn } from "./ErrorIcon/index.js";
import { EyeClosedIcon as zn } from "./EyeClosedIcon/index.js";
import { FaceIcon as On } from "./FaceIcon/index.js";
import { FacebookIcon as Bn } from "./FacebookIcon/index.js";
import { FadeDarkCirclesIcon as Vn } from "./FadeDarkCirclesIcon/index.js";
import { FemaleIcon as Nn } from "./FemaleIcon/index.js";
import { FightBreakoutsIcon as Rn } from "./FightBreakoutsIcon/index.js";
import { FinelinesIcon as Un } from "./FinelinesIcon/index.js";
import { FirmnessIcon as En } from "./FirmnessIcon/index.js";
import { FlagIcon as qn } from "./FlagIcon/index.js";
import { FormulaChangeIcon as Gn } from "./FormulaChangeIcon/index.js";
import { FrontFacingSelfieIcon as jn } from "./FrontFacingSelfieIcon/index.js";
import { GiftIcon as Wn } from "./GiftIcon/index.js";
import { GoogleIcon as Kn } from "./GoogleIcon/index.js";
import { GridIcon as Yn } from "./GridIcon/index.js";
import { HairBaldSpotsIcon as Jn } from "./HairBaldSpotsIcon/index.js";
import { HairBreakageIcon as Zn } from "./HairBreakageIcon/index.js";
import { HairFeelBetterIcon as Qn } from "./HairFeelBetterIcon/index.js";
import { HairLossFemale1Icon as Xn } from "./HairLossFemale1Icon/index.js";
import { HairLossFemale2Icon as _n } from "./HairLossFemale2Icon/index.js";
import { HairLossFemale3Icon as $n } from "./HairLossFemale3Icon/index.js";
import { HairLossMale1Icon as ec } from "./HairLossMale1Icon/index.js";
import { HairLossMale2Icon as oc } from "./HairLossMale2Icon/index.js";
import { HairLossMale3Icon as nc } from "./HairLossMale3Icon/index.js";
import { HairPreventIcon as cc } from "./HairPreventIcon/index.js";
import { HairRegrowIcon as ac } from "./HairRegrowIcon/index.js";
import { HairSheddingIcon as rc } from "./HairSheddingIcon/index.js";
import { HairThickerIcon as tc } from "./HairThickerIcon/index.js";
import { HairThinningIcon as ic } from "./HairThinningIcon/index.js";
import { HairVisibleScalpIcon as gc } from "./HairVisibleScalpIcon/index.js";
import { HeartIcon as mc } from "./HeartIcon/index.js";
import { HelpIcon as yc } from "./HelpIcon/index.js";
import { HomeIcon as pc } from "./HomeIcon/index.js";
import { HydrocortisoneIcon as lc } from "./HydrocortisoneIcon/index.js";
import { HydroquinoneIcon as sc } from "./HydroquinoneIcon/index.js";
import { ImageIcon as hc } from "./ImageIcon/index.js";
import { InfoIcon as fc } from "./InfoIcon/index.js";
import { InstagramIcon as dc } from "./InstagramIcon/index.js";
import { IvermectinIcon as Ac } from "./IvermectinIcon/index.js";
import { JcbIcon as uc } from "./JcbIcon/index.js";
import { KetoconazoleIcon as Ic } from "./KetoconazoleIcon/index.js";
import { KojicAcidIcon as kc } from "./KojicAcidIcon/index.js";
import { LeftFacingSelfieIcon as bc } from "./LeftFacingSelfieIcon/index.js";
import { LightningIcon as Cc } from "./LightningIcon/index.js";
import { LoadingIcon as vc } from "./LoadingIcon/index.js";
import { LocationIcon as wc } from "./LocationIcon/index.js";
import { LockIcon as Sc } from "./LockIcon/index.js";
import { LogoutIcon as Lc } from "./LogoutIcon/index.js";
import { MailIcon as Pc } from "./MailIcon/index.js";
import { MaleIcon as Tc } from "./MaleIcon/index.js";
import { MastercardIcon as Fc } from "./MastercardIcon/index.js";
import { MenuIcon as Mc } from "./MenuIcon/index.js";
import { MetronidazoleIcon as Hc } from "./MetronidazoleIcon/index.js";
import { MicIcon as Dc } from "./MicIcon/index.js";
import { MinusIcon as xc } from "./MinusIcon/index.js";
import { MoreIcon as zc } from "./MoreIcon/index.js";
import { NeckIcon as Oc } from "./NeckIcon/index.js";
import { NextIcon as Bc } from "./NextIcon/index.js";
import { NiacinmideIcon as Vc } from "./NiacinmideIcon/index.js";
import { OftenDryIcon as Nc } from "./OftenDryIcon/index.js";
import { OftenOilyIcon as Rc } from "./OftenOilyIcon/index.js";
import { OtherIcon as Uc } from "./OtherIcon/index.js";
import { PaperclipIcon as Ec } from "./PaperclipIcon/index.js";
import { PauseIcon as qc } from "./PauseIcon/index.js";
import { PaymentIcon as Gc } from "./PaymentIcon/index.js";
import { PayPalIcon as jc } from "./PayPalIcon/index.js";
import { PhoneIcon as Wc } from "./PhoneIcon/index.js";
import { PinterestIcon as Kc } from "./PinterestIcon/index.js";
import { PlaceholderIcon as Yc } from "./PlaceholderIcon/index.js";
import { PlanIcon as Jc } from "./PlanIcon/index.js";
import { PlayIcon as Zc } from "./PlayIcon/index.js";
import { PlusIcon as Qc } from "./PlusIcon/index.js";
import { PostcardIcon as Xc } from "./PostcardIcon/index.js";
import { PreviousIcon as _c } from "./PreviousIcon/index.js";
import { ProviderIcon as $c } from "./ProviderIcon/index.js";
import { RefreshIcon as ea } from "./RefreshIcon/index.js";
import { RightFacingSelfieIcon as oa } from "./RightFacingSelfieIcon/index.js";
import { RosaceaIcon as na } from "./RosaceaIcon/index.js";
import { RotateIcon as ca } from "./RotateIcon/index.js";
import { SearchIcon as aa } from "./SearchIcon/index.js";
import { SelfiesIcon as ra } from "./SelfiesIcon/index.js";
import { SettingsIcon as ta } from "./SettingsIcon/index.js";
import { ShuffleIcon as ia } from "./ShuffleIcon/index.js";
import { SmileIcon as ga } from "./SmileIcon/index.js";
import { SnapchatIcon as ma } from "./SnapchatIcon/index.js";
import { StarIcon as ya } from "./StarIcon/index.js";
import { Star1Icon as pa } from "./Star1Icon/index.js";
import { SunIcon as la } from "./SunIcon/index.js";
import { SunProtectionIcon as sa } from "./SunProtectionIcon/index.js";
import { TemperatureIcon as ha } from "./TemperatureIcon/index.js";
import { TextureIcon as fa } from "./TextureIcon/index.js";
import { ThumbsDownIcon as da } from "./ThumbsDownIcon/index.js";
import { ThumbsUpIcon as Aa } from "./ThumbsUpIcon/index.js";
import { TimerIcon as ua } from "./TimerIcon/index.js";
import { TooltipTriangleIcon as Ia } from "./TooltipTriangleIcon/index.js";
import { TranexAcidIcon as ka } from "./TranexAcidIcon/index.js";
import { TransferIcon as ba } from "./TransferIcon/index.js";
import { TrashIcon as Ca } from "./TrashIcon/index.js";
import { TreatmentIcon as va } from "./TreatmentIcon/index.js";
import { TretinoinIcon as wa } from "./TretinoinIcon/index.js";
import { TruckIcon as Sa } from "./TruckIcon/index.js";
import { TungstenIcon as La } from "./TungstenIcon/index.js";
import { TwitterIcon as Pa } from "./TwitterIcon/index.js";
import { UploadIcon as Ta } from "./UploadIcon/index.js";
import { UserIcon as Fa } from "./UserIcon/index.js";
import { VeryDryIcon as Ma } from "./VeryDryIcon/index.js";
import { VeryOilyIcon as Ha } from "./VeryOilyIcon/index.js";
import { VideoIcon as Da } from "./VideoIcon/index.js";
import { VisaIcon as xa } from "./VisaIcon/index.js";
import { VitaminCIcon as za } from "./VitaminCIcon/index.js";
import { WrinklesIcon as Oa } from "./WrinklesIcon/index.js";
import { YoutubeIcon as Ba } from "./YoutubeIcon/index.js";
import { ZincIcon as Va } from "./ZincIcon/index.js";
const ky = {
  AccordionCaretDown: "accordion-caret-down",
  AccordionCaretUp: "accordion-caret-up",
  Acne1: "acne-1",
  Acne3: "acne-3",
  Acne5: "acne-5",
  Acne7: "acne-7",
  Acne: "acne",
  AgencyAcne1: "agency-acne-1",
  AgencyAcne3: "agency-acne-3",
  AgencyAcne5: "agency-acne-5",
  AgencyAcne7: "agency-acne-7",
  AgencyAcne: "agency-acne",
  AgencyAlwaysClock: "agency-always-clock",
  AgencyAlways: "agency-always",
  AgencyAnxious: "agency-anxious",
  AgencyArrowLeft: "agency-arrow-left",
  AgencyArrowRight: "agency-arrow-right",
  AgencyAzelaicAcid: "agency-azelaic-acid",
  AgencyBag: "agency-bag",
  AgencyBell: "agency-bell",
  AgencyCalendar: "agency-calendar",
  AgencyCamera: "agency-camera",
  AgencyChatBubble: "agency-chat-bubble",
  AgencyCheckBadge: "agency-check-badge",
  AgencyCheckmark: "agency-checkmark",
  AgencyChest: "agency-chest",
  AgencyChevron: "agency-chevron",
  AgencyCircleAdd: "agency-circle-add",
  AgencyCircleCheckmark: "agency-circle-checkmark",
  AgencyCircleRemove: "agency-circle-remove",
  AgencyCircle: "agency-circle",
  AgencyCleanser: "agency-cleanser",
  AgencyClipboard: "agency-clipboard",
  AgencyClock: "agency-clock",
  AgencyCloggedPores: "agency-clogged-pores",
  AgencyCloud: "agency-cloud",
  AgencyCombination: "agency-combination",
  AgencyConfused: "agency-confused",
  AgencyConsultHistory: "agency-consult-history",
  AgencyCross: "agency-cross",
  AgencyDarkSpots: "agency-dark-spots",
  AgencyDownload: "agency-download",
  AgencyDrop: "agency-drop",
  AgencyDropper: "agency-dropper",
  AgencyEdit: "agency-edit",
  AgencyElated: "agency-elated",
  AgencyEquals: "agency-equals",
  AgencyError: "agency-error",
  AgencyEyeClosed: "agency-eye-closed",
  AgencyFace: "agency-face",
  AgencyFemale: "agency-female",
  AgencyFinelines: "agency-finelines",
  AgencyFirmnessFlag: "agency-firmness-flag",
  AgencyFirmness: "agency-firmness",
  AgencyFlagCanada: "agency-flag-canada",
  AgencyFlagUk: "agency-flag-uk",
  AgencyFlagUsa: "agency-flag-usa",
  AgencyFlag: "agency-flag",
  AgencyFurious: "agency-furious",
  AgencyGift: "agency-gift",
  AgencyGlobe: "agency-globe",
  AgencyGrid: "agency-grid",
  AgencyHeartComplete: "agency-heart-complete",
  AgencyHeart: "agency-heart",
  AgencyHelp: "agency-help",
  AgencyHome: "agency-home",
  AgencyHug: "agency-hug",
  AgencyImage: "agency-image",
  AgencyInfo: "agency-info",
  AgencyLightning: "agency-lightning",
  AgencyLocation: "agency-location",
  AgencyLock: "agency-lock",
  AgencyLogoLockupInverse: "agency-logo-lockup-inverse",
  AgencyLogoLockup: "agency-logo-lockup",
  AgencyLogoStickerInverse: "agency-logo-sticker-inverse",
  AgencyLogoSticker: "agency-logo-sticker",
  AgencyLogoWordmark: "agency-logo-wordmark",
  AgencyLogo: "agency-logo",
  AgencyLogout: "agency-logout",
  AgencyLunch: "agency-lunch",
  AgencyMail: "agency-mail",
  AgencyMale: "agency-male",
  AgencyMelasma: "agency-melasma",
  AgencyMenu: "agency-menu",
  AgencyMessage: "agency-message",
  AgencyMic: "agency-mic",
  AgencyMildIrritation: "agency-mild-irritation",
  AgencyMinus: "agency-minus",
  AgencyMixIngredients: "agency-mix-ingredients",
  AgencyMoisturizer: "agency-moisturizer",
  AgencyMore: "agency-more",
  AgencyMortor: "agency-mortor",
  AgencyMostOfTimeClock: "agency-most-of-time-clock",
  AgencyMostOfTime: "agency-most-of-time",
  AgencyNeck: "agency-neck",
  AgencyNeverClock: "agency-never-clock",
  AgencyNever: "agency-never",
  AgencyNiacinamide: "agency-niacinamide",
  AgencyNoMakeup: "agency-no-makeup",
  AgencyNone: "agency-none",
  AgencyNoticeableIrritation: "agency-noticeable-irritation",
  AgencyOftenDry: "agency-often-dry",
  AgencyOftenOily: "agency-often-oily",
  AgencyOther: "agency-other",
  AgencyOverwhelmed: "agency-overwhelmed",
  AgencyPackaging: "agency-packaging",
  AgencyPalmTree: "agency-palm-tree",
  AgencyPaperclip: "agency-paperclip",
  AgencyPause: "agency-pause",
  AgencyPayment: "agency-payment",
  AgencyPhone: "agency-phone",
  AgencyPlan: "agency-plan",
  AgencyPlay: "agency-play",
  AgencyPlus: "agency-plus",
  AgencyPrepared: "agency-prepared",
  AgencyProvider: "agency-provider",
  AgencyRocketship: "agency-rocketship",
  AgencySatisfied: "agency-satisfied",
  AgencySearch: "agency-search",
  AgencySelfies: "agency-selfies",
  AgencySettings: "agency-settings",
  AgencySevereIrritation: "agency-severe-irritation",
  AgencySmile: "agency-smile",
  AgencySmiley: "agency-smiley",
  AgencySometimesClock: "agency-sometimes-clock",
  AgencySometimes: "agency-sometimes",
  AgencySparkle: "agency-sparkle",
  AgencyStar: "agency-star",
  AgencySun: "agency-sun",
  AgencySunblock: "agency-sunblock",
  AgencySunscreen: "agency-sunscreen",
  AgencySuperbottle: "agency-superbottle",
  AgencySupportCenter: "agency-support-center",
  AgencyTemperature: "agency-temperature",
  AgencyTexture: "agency-texture",
  AgencyThumbsDown: "agency-thumbs-down",
  AgencyThumbsUp: "agency-thumbs-up",
  AgencyTimer: "agency-timer",
  AgencyTransfer: "agency-transfer",
  AgencyTrash: "agency-trash",
  AgencyTreatmentPlan: "agency-treatment-plan",
  AgencyTreatment: "agency-treatment",
  AgencyTretinoin: "agency-tretinoin",
  AgencyTruck: "agency-truck",
  AgencyUnsatisfied: "agency-unsatisfied",
  AgencyUpload: "agency-upload",
  AgencyUser: "agency-user",
  AgencyVeryDry: "agency-very-dry",
  AgencyVeryOily: "agency-very-oily",
  AgencyVideo: "agency-video",
  AgencyVitaminCSerum: "agency-vitamin-c-serum",
  AgencyVitaminC: "agency-vitamin-c",
  AgencyWrinkles: "agency-wrinkles",
  AgencyYes: "agency-yes",
  Amex: "amex",
  Apple: "apple",
  ArrowLeft: "arrow-left",
  ArrowRight: "arrow-right",
  AzelaicAcid: "azelaic-acid",
  Bag: "bag",
  Bell: "bell",
  Calendar: "calendar",
  Camera: "camera",
  ChatBubble: "chat-bubble",
  Checkmark: "checkmark",
  Chest: "chest",
  Chevron: "chevron",
  CircleAdd: "circle-add",
  CircleCheck: "circle-check",
  CircleRemove: "circle-remove",
  Circle: "circle",
  Clindamycin: "clindamycin",
  Clipboard: "clipboard",
  Clock: "clock",
  CloggedPores: "clogged-pores",
  Cloud: "cloud",
  Combination: "combination",
  Contrast: "contrast",
  Cross: "cross",
  CurologyLogoLockupInverse: "curology-logo-lockup-inverse",
  CurologyLogoLockup: "curology-logo-lockup",
  CurologyLogoSticker: "curology-logo-sticker",
  CurologyLogoWordmark: "curology-logo-wordmark",
  DarkSpots: "dark-spots",
  Dash: "dash",
  Desonide: "desonide",
  DinersClub: "diners-club",
  Discover: "discover",
  Dot: "dot",
  Download: "download",
  Drop: "drop",
  Edit: "edit",
  Equal: "equal",
  Error: "error",
  EyeClosed: "eye-closed",
  Face: "face",
  Facebook: "facebook",
  FadeDarkCircles: "fade-dark-circles",
  Female: "female",
  FightBreakouts: "fight-breakouts",
  Finelines: "finelines",
  Firmness: "firmness",
  Flag: "flag",
  FormulaChange: "formula-change",
  FrontFacingSelfie: "front-facing-selfie",
  Gift: "gift",
  Google: "google",
  Grid: "grid",
  HairBaldSpots: "hair-bald-spots",
  HairBreakage: "hair-breakage",
  HairFeelBetter: "hair-feel-better",
  HairLossFemale1: "hair-loss-female-1",
  HairLossFemale2: "hair-loss-female-2",
  HairLossFemale3: "hair-loss-female-3",
  HairLossMale1: "hair-loss-male-1",
  HairLossMale2: "hair-loss-male-2",
  HairLossMale3: "hair-loss-male-3",
  HairPrevent: "hair-prevent",
  HairRegrow: "hair-regrow",
  HairShedding: "hair-shedding",
  HairThicker: "hair-thicker",
  HairThinning: "hair-thinning",
  HairVisibleScalp: "hair-visible-scalp",
  Heart: "heart",
  Help: "help",
  Home: "home",
  Hydrocortisone: "hydrocortisone",
  Hydroquinone: "hydroquinone",
  Image: "image",
  Info: "info",
  Instagram: "instagram",
  Ivermectin: "ivermectin",
  Jcb: "jcb",
  Ketoconazole: "ketoconazole",
  KojicAcid: "kojic-acid",
  LeftFacingSelfie: "left-facing-selfie",
  Lightning: "lightning",
  Loading: "loading",
  Location: "location",
  Lock: "lock",
  Logout: "logout",
  Mail: "mail",
  Male: "male",
  Mastercard: "mastercard",
  Menu: "menu",
  Metronidazole: "metronidazole",
  Mic: "mic",
  Minus: "minus",
  More: "more",
  Neck: "neck",
  Next: "next",
  Niacinmide: "niacinmide",
  OftenDry: "often-dry",
  OftenOily: "often-oily",
  Other: "other",
  Paperclip: "paperclip",
  Pause: "pause",
  PayPal: "payPal",
  Payment: "payment",
  Phone: "phone",
  Pinterest: "pinterest",
  Placeholder: "placeholder",
  Plan: "plan",
  Play: "play",
  Plus: "plus",
  Postcard: "postcard",
  Previous: "previous",
  Provider: "provider",
  Refresh: "refresh",
  RightFacingSelfie: "right-facing-selfie",
  Rosacea: "rosacea",
  Rotate: "rotate",
  Search: "search",
  Selfies: "selfies",
  Settings: "settings",
  Shuffle: "shuffle",
  Smile: "smile",
  Snapchat: "snapchat",
  Star1: "star-1",
  Star: "star",
  SunProtection: "sun-protection",
  Sun: "sun",
  Temperature: "temperature",
  Texture: "texture",
  ThumbsDown: "thumbs-down",
  ThumbsUp: "thumbs-up",
  Timer: "timer",
  TooltipTriangle: "tooltip-triangle",
  TranexAcid: "tranex-acid",
  Transfer: "transfer",
  Trash: "trash",
  Treatment: "treatment",
  Tretinoin: "tretinoin",
  Truck: "truck",
  Tungsten: "tungsten",
  Twitter: "twitter",
  Upload: "upload",
  User: "user",
  VeryDry: "very-dry",
  VeryOily: "very-oily",
  Video: "video",
  Visa: "visa",
  VitaminC: "vitamin-c",
  Wrinkles: "wrinkles",
  Youtube: "youtube",
  Zinc: "zinc"
}, by = {
  "accordion-caret-down": "stroke",
  "accordion-caret-up": "stroke",
  "acne-1": "stroke",
  "acne-3": "path",
  "acne-5": "path",
  "acne-7": "path",
  acne: "path",
  "agency-acne-1": "path",
  "agency-acne-3": "path",
  "agency-acne-5": "path",
  "agency-acne-7": "path",
  "agency-acne": "path",
  "agency-always-clock": "path",
  "agency-always": "path",
  "agency-anxious": "path",
  "agency-arrow-left": "path",
  "agency-arrow-right": "path",
  "agency-azelaic-acid": "path",
  "agency-bag": "path",
  "agency-bell": "path",
  "agency-calendar": "path",
  "agency-camera": "path",
  "agency-chat-bubble": "path",
  "agency-check-badge": "path",
  "agency-checkmark": "path",
  "agency-chest": "path",
  "agency-chevron": "path",
  "agency-circle-add": "path",
  "agency-circle-checkmark": "path",
  "agency-circle-remove": "path",
  "agency-circle": "path",
  "agency-cleanser": "path",
  "agency-clipboard": "path",
  "agency-clock": "path",
  "agency-clogged-pores": "path",
  "agency-cloud": "path",
  "agency-combination": "path",
  "agency-confused": "path",
  "agency-consult-history": "path",
  "agency-cross": "path",
  "agency-dark-spots": "path",
  "agency-download": "path",
  "agency-drop": "path",
  "agency-dropper": "path",
  "agency-edit": "path",
  "agency-elated": "path",
  "agency-equals": "path",
  "agency-error": "path",
  "agency-eye-closed": "path",
  "agency-face": "path",
  "agency-female": "path",
  "agency-finelines": "path",
  "agency-firmness-flag": "path",
  "agency-firmness": "path",
  "agency-flag-canada": "path",
  "agency-flag-uk": "path",
  "agency-flag-usa": "path",
  "agency-flag": "path",
  "agency-furious": "path",
  "agency-gift": "path",
  "agency-globe": "path",
  "agency-grid": "path",
  "agency-heart-complete": "path",
  "agency-heart": "path",
  "agency-help": "path",
  "agency-home": "path",
  "agency-hug": "path",
  "agency-image": "path",
  "agency-info": "path",
  "agency-lightning": "path",
  "agency-location": "path",
  "agency-lock": "path",
  "agency-logo-lockup-inverse": null,
  "agency-logo-lockup": null,
  "agency-logo-sticker-inverse": null,
  "agency-logo-sticker": null,
  "agency-logo-wordmark": null,
  "agency-logo": null,
  "agency-logout": "path",
  "agency-lunch": "path",
  "agency-mail": "path",
  "agency-male": "path",
  "agency-melasma": "path",
  "agency-menu": "path",
  "agency-message": "path",
  "agency-mic": "path",
  "agency-mild-irritation": "path",
  "agency-minus": "path",
  "agency-mix-ingredients": "path",
  "agency-moisturizer": "path",
  "agency-more": "path",
  "agency-mortor": "path",
  "agency-most-of-time-clock": "path",
  "agency-most-of-time": "path",
  "agency-neck": "path",
  "agency-never-clock": "path",
  "agency-never": "path",
  "agency-niacinamide": "path",
  "agency-no-makeup": "path",
  "agency-none": "path",
  "agency-noticeable-irritation": "path",
  "agency-often-dry": "path",
  "agency-often-oily": "path",
  "agency-other": "path",
  "agency-overwhelmed": "path",
  "agency-packaging": "path",
  "agency-palm-tree": "path",
  "agency-paperclip": "path",
  "agency-pause": "path",
  "agency-payment": "path",
  "agency-phone": "path",
  "agency-plan": "path",
  "agency-play": "path",
  "agency-plus": "path",
  "agency-prepared": "path",
  "agency-provider": "path",
  "agency-rocketship": "path",
  "agency-satisfied": "path",
  "agency-search": "path",
  "agency-selfies": "path",
  "agency-settings": "path",
  "agency-severe-irritation": "path",
  "agency-smile": "path",
  "agency-smiley": "path",
  "agency-sometimes-clock": "path",
  "agency-sometimes": "path",
  "agency-sparkle": "path",
  "agency-star": "path",
  "agency-sun": "path",
  "agency-sunblock": "path",
  "agency-sunscreen": "path",
  "agency-superbottle": "path",
  "agency-support-center": "path",
  "agency-temperature": "path",
  "agency-texture": "path",
  "agency-thumbs-down": "path",
  "agency-thumbs-up": "path",
  "agency-timer": "path",
  "agency-transfer": "path",
  "agency-trash": "path",
  "agency-treatment-plan": "path",
  "agency-treatment": "path",
  "agency-tretinoin": "path",
  "agency-truck": "path",
  "agency-unsatisfied": "path",
  "agency-upload": "path",
  "agency-user": "path",
  "agency-very-dry": "path",
  "agency-very-oily": "path",
  "agency-video": "path",
  "agency-vitamin-c-serum": "path",
  "agency-vitamin-c": "path",
  "agency-wrinkles": "path",
  "agency-yes": "path",
  amex: null,
  apple: "path",
  "arrow-left": "path",
  "arrow-right": "path",
  "azelaic-acid": "path",
  bag: "path",
  bell: "path",
  calendar: "path",
  camera: "path",
  "chat-bubble": "path",
  checkmark: "stroke",
  chest: "path",
  chevron: "path",
  "circle-add": "path",
  "circle-check": "path",
  "circle-remove": "path",
  circle: "stroke",
  clindamycin: "path",
  clipboard: "path",
  clock: "path",
  "clogged-pores": "path",
  cloud: "path",
  combination: "path",
  contrast: "path",
  cross: "path",
  "curology-logo-lockup-inverse": null,
  "curology-logo-lockup": null,
  "curology-logo-sticker": null,
  "curology-logo-wordmark": null,
  "dark-spots": "path",
  dash: "path",
  desonide: "path",
  "diners-club": null,
  discover: null,
  dot: "path",
  download: "path",
  drop: "path",
  edit: "path",
  equal: "path",
  error: "path",
  "eye-closed": "path",
  face: null,
  facebook: "path",
  "fade-dark-circles": "path",
  female: "path",
  "fight-breakouts": "path",
  finelines: "path",
  firmness: "path",
  flag: "path",
  "formula-change": "path",
  "front-facing-selfie": "path",
  gift: "path",
  google: "path",
  grid: "path",
  "hair-bald-spots": "path",
  "hair-breakage": "path",
  "hair-feel-better": "path",
  "hair-loss-female-1": "path",
  "hair-loss-female-2": "path",
  "hair-loss-female-3": "path",
  "hair-loss-male-1": "path",
  "hair-loss-male-2": "path",
  "hair-loss-male-3": "path",
  "hair-prevent": "path",
  "hair-regrow": "path",
  "hair-shedding": "path",
  "hair-thicker": "path",
  "hair-thinning": "path",
  "hair-visible-scalp": "path",
  heart: "path",
  help: null,
  home: "path",
  hydrocortisone: "path",
  hydroquinone: "path",
  image: "path",
  info: "path",
  instagram: "path",
  ivermectin: "path",
  jcb: null,
  ketoconazole: "path",
  "kojic-acid": "path",
  "left-facing-selfie": "path",
  lightning: "path",
  loading: "stroke",
  location: "path",
  lock: "path",
  logout: "path",
  mail: "path",
  male: "path",
  mastercard: null,
  menu: "path",
  metronidazole: "path",
  mic: "path",
  minus: "path",
  more: "path",
  neck: "path",
  next: "path",
  niacinmide: "path",
  "often-dry": "path",
  "often-oily": "path",
  other: "path",
  paperclip: "path",
  pause: "path",
  payPal: "path",
  payment: "path",
  phone: "path",
  pinterest: "path",
  placeholder: null,
  plan: "path",
  play: "path",
  plus: "path",
  postcard: "path",
  previous: "path",
  provider: "path",
  refresh: "path",
  "right-facing-selfie": "path",
  rosacea: "path",
  rotate: "path",
  search: "path",
  selfies: "path",
  settings: "path",
  shuffle: "path",
  smile: "path",
  snapchat: "path",
  "star-1": "path",
  star: "path",
  "sun-protection": "path",
  sun: "path",
  temperature: "path",
  texture: "path",
  "thumbs-down": "path",
  "thumbs-up": "path",
  timer: "path",
  "tooltip-triangle": "stroke",
  "tranex-acid": "path",
  transfer: "path",
  trash: "path",
  treatment: "path",
  tretinoin: "path",
  truck: "path",
  tungsten: "path",
  twitter: "path",
  upload: "path",
  user: "path",
  "very-dry": "path",
  "very-oily": "path",
  video: "path",
  visa: null,
  "vitamin-c": "path",
  wrinkles: "path",
  youtube: "path",
  zinc: "path"
}, Cy = {
  "accordion-caret-down": e,
  "accordion-caret-up": o,
  acne: n,
  "acne-1": c,
  "acne-3": a,
  "acne-5": r,
  "acne-7": t,
  "agency-acne": i,
  "agency-acne-1": g,
  "agency-acne-3": m,
  "agency-acne-5": y,
  "agency-acne-7": p,
  "agency-always": l,
  "agency-always-clock": s,
  "agency-anxious": h,
  "agency-arrow-left": f,
  "agency-arrow-right": d,
  "agency-azelaic-acid": A,
  "agency-bag": u,
  "agency-bell": I,
  "agency-calendar": k,
  "agency-camera": b,
  "agency-chat-bubble": C,
  "agency-check-badge": v,
  "agency-checkmark": w,
  "agency-chest": S,
  "agency-chevron": L,
  "agency-circle": P,
  "agency-circle-add": T,
  "agency-circle-checkmark": F,
  "agency-circle-remove": M,
  "agency-cleanser": H,
  "agency-clipboard": D,
  "agency-clock": x,
  "agency-clogged-pores": z,
  "agency-cloud": O,
  "agency-combination": B,
  "agency-confused": V,
  "agency-consult-history": N,
  "agency-cross": R,
  "agency-dark-spots": U,
  "agency-download": E,
  "agency-drop": q,
  "agency-dropper": G,
  "agency-edit": j,
  "agency-elated": W,
  "agency-equals": K,
  "agency-error": Y,
  "agency-eye-closed": J,
  "agency-face": Z,
  "agency-female": Q,
  "agency-finelines": X,
  "agency-firmness": _,
  "agency-firmness-flag": $,
  "agency-flag": ee,
  "agency-flag-canada": oe,
  "agency-flag-uk": ne,
  "agency-flag-usa": ce,
  "agency-furious": ae,
  "agency-gift": re,
  "agency-globe": te,
  "agency-grid": ie,
  "agency-heart": ge,
  "agency-heart-complete": me,
  "agency-help": ye,
  "agency-home": pe,
  "agency-hug": le,
  "agency-image": se,
  "agency-info": he,
  "agency-lightning": fe,
  "agency-location": de,
  "agency-lock": Ae,
  "agency-logo": ue,
  "agency-logo-lockup": Ie,
  "agency-logo-lockup-inverse": ke,
  "agency-logo-sticker": be,
  "agency-logo-sticker-inverse": Ce,
  "agency-logo-wordmark": ve,
  "agency-logout": we,
  "agency-lunch": Se,
  "agency-mail": Le,
  "agency-male": Pe,
  "agency-melasma": Te,
  "agency-menu": Fe,
  "agency-message": Me,
  "agency-mic": He,
  "agency-mild-irritation": De,
  "agency-minus": xe,
  "agency-mix-ingredients": ze,
  "agency-moisturizer": Oe,
  "agency-more": Be,
  "agency-mortor": Ve,
  "agency-most-of-time": Ne,
  "agency-most-of-time-clock": Re,
  "agency-neck": Ue,
  "agency-never": Ee,
  "agency-never-clock": qe,
  "agency-niacinamide": Ge,
  "agency-no-makeup": je,
  "agency-none": We,
  "agency-noticeable-irritation": Ke,
  "agency-often-dry": Ye,
  "agency-often-oily": Je,
  "agency-other": Ze,
  "agency-overwhelmed": Qe,
  "agency-packaging": Xe,
  "agency-palm-tree": _e,
  "agency-paperclip": $e,
  "agency-pause": eo,
  "agency-payment": oo,
  "agency-phone": no,
  "agency-plan": co,
  "agency-play": ao,
  "agency-plus": ro,
  "agency-prepared": to,
  "agency-provider": io,
  "agency-rocketship": go,
  "agency-satisfied": mo,
  "agency-search": yo,
  "agency-selfies": po,
  "agency-settings": lo,
  "agency-severe-irritation": so,
  "agency-smile": ho,
  "agency-smiley": fo,
  "agency-sometimes": Ao,
  "agency-sometimes-clock": uo,
  "agency-sparkle": Io,
  "agency-star": ko,
  "agency-sun": bo,
  "agency-sunblock": Co,
  "agency-sunscreen": vo,
  "agency-superbottle": wo,
  "agency-support-center": So,
  "agency-temperature": Lo,
  "agency-texture": Po,
  "agency-thumbs-down": To,
  "agency-thumbs-up": Fo,
  "agency-timer": Mo,
  "agency-transfer": Ho,
  "agency-trash": Do,
  "agency-treatment": xo,
  "agency-treatment-plan": zo,
  "agency-tretinoin": Oo,
  "agency-truck": Bo,
  "agency-unsatisfied": Vo,
  "agency-upload": No,
  "agency-user": Ro,
  "agency-very-dry": Uo,
  "agency-very-oily": Eo,
  "agency-video": qo,
  "agency-vitamin-c": Go,
  "agency-vitamin-c-serum": jo,
  "agency-wrinkles": Wo,
  "agency-yes": Ko,
  amex: Yo,
  apple: Jo,
  "arrow-left": Zo,
  "arrow-right": Qo,
  "azelaic-acid": Xo,
  bag: _o,
  bell: $o,
  calendar: en,
  camera: on,
  "chat-bubble": nn,
  checkmark: cn,
  chest: an,
  chevron: rn,
  circle: tn,
  "circle-add": gn,
  "circle-check": mn,
  "circle-remove": yn,
  clindamycin: pn,
  clipboard: ln,
  clock: sn,
  "clogged-pores": hn,
  cloud: fn,
  combination: dn,
  contrast: An,
  cross: un,
  "curology-logo-lockup": In,
  "curology-logo-lockup-inverse": kn,
  "curology-logo-sticker": bn,
  "curology-logo-wordmark": Cn,
  "dark-spots": vn,
  dash: wn,
  desonide: Sn,
  "diners-club": Ln,
  discover: Pn,
  dot: Tn,
  download: Fn,
  drop: Mn,
  edit: Hn,
  equal: Dn,
  error: xn,
  "eye-closed": zn,
  face: On,
  facebook: Bn,
  "fade-dark-circles": Vn,
  female: Nn,
  "fight-breakouts": Rn,
  finelines: Un,
  firmness: En,
  flag: qn,
  "formula-change": Gn,
  "front-facing-selfie": jn,
  gift: Wn,
  google: Kn,
  grid: Yn,
  "hair-bald-spots": Jn,
  "hair-breakage": Zn,
  "hair-feel-better": Qn,
  "hair-loss-female-1": Xn,
  "hair-loss-female-2": _n,
  "hair-loss-female-3": $n,
  "hair-loss-male-1": ec,
  "hair-loss-male-2": oc,
  "hair-loss-male-3": nc,
  "hair-prevent": cc,
  "hair-regrow": ac,
  "hair-shedding": rc,
  "hair-thicker": tc,
  "hair-thinning": ic,
  "hair-visible-scalp": gc,
  heart: mc,
  help: yc,
  home: pc,
  hydrocortisone: lc,
  hydroquinone: sc,
  image: hc,
  info: fc,
  instagram: dc,
  ivermectin: Ac,
  jcb: uc,
  ketoconazole: Ic,
  "kojic-acid": kc,
  "left-facing-selfie": bc,
  lightning: Cc,
  loading: vc,
  location: wc,
  lock: Sc,
  logout: Lc,
  mail: Pc,
  male: Tc,
  mastercard: Fc,
  menu: Mc,
  metronidazole: Hc,
  mic: Dc,
  minus: xc,
  more: zc,
  neck: Oc,
  next: Bc,
  niacinmide: Vc,
  "often-dry": Nc,
  "often-oily": Rc,
  other: Uc,
  paperclip: Ec,
  pause: qc,
  payment: Gc,
  payPal: jc,
  phone: Wc,
  pinterest: Kc,
  placeholder: Yc,
  plan: Jc,
  play: Zc,
  plus: Qc,
  postcard: Xc,
  previous: _c,
  provider: $c,
  refresh: ea,
  "right-facing-selfie": oa,
  rosacea: na,
  rotate: ca,
  search: aa,
  selfies: ra,
  settings: ta,
  shuffle: ia,
  smile: ga,
  snapchat: ma,
  star: ya,
  "star-1": pa,
  sun: la,
  "sun-protection": sa,
  temperature: ha,
  texture: fa,
  "thumbs-down": da,
  "thumbs-up": Aa,
  timer: ua,
  "tooltip-triangle": Ia,
  "tranex-acid": ka,
  transfer: ba,
  trash: Ca,
  treatment: va,
  tretinoin: wa,
  truck: Sa,
  tungsten: La,
  twitter: Pa,
  upload: Ta,
  user: Fa,
  "very-dry": Ma,
  "very-oily": Ha,
  video: Da,
  visa: xa,
  "vitamin-c": za,
  wrinkles: Oa,
  youtube: Ba,
  zinc: Va
};
export {
  ky as IconName,
  by as iconFillMap,
  Cy as icons
};
//# sourceMappingURL=index.js.map
